"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _moment = _interopRequireDefault(require("moment"));
function getSecondsTo(startOn) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _moment["default"])();
  return (0, _moment["default"])(startOn).diff(now, 'seconds');
}
var _default = exports["default"] = getSecondsTo;